var calculateShowLeft = function (dom, mountDOM) {
    var domWidth = dom.clientWidth;
    var mountRect = mountDOM.getBoundingClientRect();
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (mountRect.left < 0)
        return -mountRect.left;
    if (mountRect.left + domWidth < viewportWidth)
        return 0;
    return -(domWidth - (viewportWidth - mountRect.left));
};
export { calculateShowLeft };
//# sourceMappingURL=utils.js.map